export const GET_NEW_TRIP_REQUEST = 'GET_NEW_TRIP_REQUEST' as const;
export const GET_NEW_TRIP_SUCCESS = 'GET_NEW_TRIP_SUCCESS' as const;
export const GET_NEW_TRIP_ERROR = 'GET_NEW_TRIP_ERROR' as const;

export const SET_VISITOR_NAME = 'SET_VISITOR_NAME' as const;

export const SET_SMS_FLAG = 'SET_SMS_FLAG' as const;

export const GET_TRIP_REQUEST = 'GET_TRIP_REQUEST' as const;
export const GET_TRIP_SUCCESS = 'GET_TRIP_SUCCESS' as const;
export const GET_TRIP_ERROR = 'GET_TRIP_ERROR' as const;

export const UPDATE_TRIP_REQUEST = 'UPDATE_TRIP_REQUEST' as const;
export const UPDATE_TRIP_SUCCESS = 'UPDATE_TRIP_SUCCESS' as const;
export const UPDATE_TRIP_ERROR = 'UPDATE_TRIP_ERROR' as const;
export const UPDATE_TRIP_STATUS = 'UPDATE_TRIP_STATUS' as const;
export const UPDATE_TRIP_STATUS_SUCCESS = 'UPDATE_TRIP_STATUS_SUCCESS' as const;
export const UPDATE_NEW_TRIP_SUCCESS = 'UPDATE_NEW_TRIP_SUCCESS' as const;

export const DELETE_TRIP_REQUEST = 'DELETE_TRIP_REQUEST' as const;
export const DELETE_TRIP_SUCCESS = 'DELETE_TRIP_SUCCESS' as const;
export const DELETE_TRIP_ERROR = 'DELETE_TRIP_ERROR' as const;

export const SAVED_TRIP = 'SAVED_TRIP' as const;
export const FORCE_SAVED = 'FORCE_SAVED' as const;
export const CLEAN_TRIP = 'CLEAN_TRIP' as const;
export const CLEAN_ERROR = 'CLEAN_ERROR' as const;

export const DELETE_ORDER_FROM_TRIP_REQUEST = 'DELETE_ORDER_FROM_TRIP_REQUEST' as const;
export const DELETE_ORDER_FROM_TRIP_SUCCESS = 'DELETE_ORDER_FROM_TRIP_SUCCESS' as const;
export const DELETE_ORDER_FROM_TRIP_ERROR = 'DELETE_ORDER_FROM_TRIP_ERROR' as const;

export const PUT_NEXT_STEP_REQUEST = 'PUT_NEXT_STEP_REQUEST' as const;
export const PUT_NEXT_STEP_SUCCESS = 'PUT_NEXT_STEP_SUCCESS' as const;
export const PUT_NEXT_STEP_ERROR = 'PUT_NEXT_STEP_ERROR' as const;

export const HAS_WARNING = 'HAS_WARNING' as const;
export const CLEAN_WARNING = 'CLEAN_WARNING' as const;
